<template>
  <b-input-group class="dateselector mr-3">
    <template v-slot:prepend>
      <b-dropdown
        :text="selectedTime.text"
        class="month mb-3"
        variant="outline-secondary"
      >
        <b-dropdown-item
          v-for="(item, index) in timerange"
          :key="index"
          @click="setDate(item)"
          :active="item.isActive"
          >{{ item.text }}</b-dropdown-item
        >
      </b-dropdown>
    </template>
    <v-date-picker
      class="calendar mb-3"
      mode="range"
      v-model="localRange"
      :masks="{ input: 'YYYY-MM-DD' }"
      :popover="{ visibility: 'click' }"
      @popoverDidHide="popoverDidHide"
      :columns="$screens({ default: 1, md: 2 })"
    ></v-date-picker>
  </b-input-group>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "OposDatepicker",
  props: {
    range: { type: Object, default: null },
    selected: { type: Object, default: null },
  },
  data() {
    return {
      selectedTime: null,
      lastRange: null,
      timerange: [
        { text: "Ten rok", value: "this_year" },
        { text: "Ten i poprzedni rok", value: "thislast_year" },
        { text: "Poprzedni rok", value: "last_year" },
        { text: "Inny zakres", value: "custom" },
      ],
      localRange: {
        start: null,
        end: null,
      },
    };
  },
  computed: {
    dateChange() {
      if (this.lastRange === null) return true;
      return !(
        dayjs(this.localRange.start).isSame(this.lastRange.start) &&
        dayjs(this.localRange.end).isSame(this.lastRange.end)
      );
    },
  },
  created() {
    let pick = null;
    if (this.range) {
      pick = this.$_.find(this.timerange, { value: this.selected.value });
    }
    if (!pick) {
      pick = this.timerange[0];
    }
    if (this.range) {
      this.lastRange = {};
      this.lastRange.start = this.range.start;
      this.lastRange.end = this.range.end;
      this.localRange.start = this.range.start;
      this.localRange.end = this.range.end;
    }
    this.setDate(pick);
  },
  methods: {
    popoverDidHide: function () {
      if (this.dateChange === true) {
        this.setDate(this.timerange[this.timerange.length - 1]);
      }
    },
    setDate: function (item) {
      if (this.selectedTime) {
        this.selectedTime.isActive = false;
      }
      item.isActive = true;
      this.selectedTime = item;
      let today = dayjs();
      if (item.value !== "custom") {
        let options = item.value.split("_");
        if (options[0] === "last") {
          today = today.subtract(1, options[1]);
        }
        //Aktualny rok i poprzedni
        if (options[0] === "thislast") {
          let today = dayjs();
          let lastYearStart = today.subtract(1, "year").startOf("year");
          let thisYearEnd = today.endOf("year");
          this.localRange = {
            start: lastYearStart.toDate(),
            end: thisYearEnd.toDate()
          };

        } else {
          this.localRange = {
            start: today.startOf(options[1]).toDate(),
            end: today.endOf(options[1]).toDate(),
          };
        }
      }
      if (this.dateChange) {
        this.emitRange();
      }
    },
    emitRange() {
      this.lastRange = {
        start: this.localRange.start,
        end: this.localRange.end,
      };
      this.$emit("input", this.localRange, this.selectedTime);
    },
  },
};
</script>
